package com.milta.core.localization.translations.es

import com.milta.core.localization.WebDashboardStrings

internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Actualizar",
    expandedStopsTitle = "Paradas",
    stopStatusWaitingLabel = "En espera",
    stopStatusFailedLabel = "No entregado",
)
